import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { VisionStep } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';

/**
 * VO représentant une étape de calcul d'une vision
 * Réduit à son minimum pour utilisation par le moteur
 */
export class VisionStepVO {

    constructor(model: Model, pSource?: VisionStep) {
        this._model = model;
        if (pSource) {
            this.source = pSource;
        } else {
            this.source = new VisionStep();
            this.source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
        }
    }

    protected _model: Model;

    /** L'objet source provenant du back */
    public source: VisionStep;

    public get code(): string {
        return this.source.code;
    }
    public set code(pValue: string) {
        this.source.code = pValue;
    }

    // niveau du step
    public get level(): number {
        return this.source.level;
    }
    public set level(value: number) {
        this.source.level = value;
    }

}
